var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.81048 13.625C6.29911 13.625 5.88477 13.2107 5.88477 12.6993V0.925712C5.88477 0.414349 6.29911 0 6.81048 0C7.32184 0 7.73619 0.414349 7.73619 0.925712V12.6993C7.73619 13.2107 7.32184 13.625 6.81048 13.625Z",
    fill: "#121212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6993 7.73424H0.925712C0.414349 7.73424 0 7.31989 0 6.80852C0 6.29716 0.414349 5.88281 0.925712 5.88281H12.6993C13.2107 5.88281 13.625 6.29716 13.625 6.80852C13.625 7.31989 13.2107 7.73424 12.6993 7.73424Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.67f139df67818f6fb1943f63a84f2a7c.svg";
export { ForwardRef as ReactComponent };